import React from 'react';
import Select from '../Form/Select.tsx';
import Button from '../Form/Button.tsx';
import InlineClientAccountForm from './InlineClientAccountForm.tsx';
import { IClientAccount } from '../../interface/IClientAccount.ts';
import { IOption } from '../../interface/IOption.ts';

export interface DraftAccount {
    tempId:string,
    data:IClientAccount,
    label:string,
}

export const ADD_NEW_VALUE = '__add_new__';

const accountLabel = (account:IClientAccount, privateType:IOption, companyType:IOption) => {    
    const accountType = String(account.client_account_type ?? '');
    const typeLabel = companyType && accountType === String(companyType.id)
        ? 'Geschäftlich'
        : (privateType && accountType === String(privateType.id) ? 'Privat' : '');
    return account.client_account_billing_name + (typeLabel ? ` | ${typeLabel}` : '') || 'Rechnungskonto';
} 

interface ExamTypeAccountSelectProps {
    accounts:Array<IClientAccount>,
    assignment:string|null,
    onAssign:(value:string|null) => void,
    onAddNew:() => void,
    inlineOpen:boolean,
    inlineDraft:IClientAccount|null,
    inlineErrors:{ [key:string]:string },
    inlineSaving?:boolean,
    inlineSaveError?:string,
    onInlineChange:(next:IClientAccount) => void,
    onInlineSave:() => void,
    onInlineCancel:() => void,
    privateType:IOption,
    companyType:IOption,
}

const ExamTypeAccountSelect = ({
    accounts,
    assignment,
    onAssign,
    onAddNew,
    inlineOpen,
    inlineDraft,
    inlineErrors,
    inlineSaving,
    inlineSaveError,
    onInlineChange,
    onInlineSave,
    onInlineCancel,
    privateType,
    companyType,
}:ExamTypeAccountSelectProps) => {
    const options:Array<IOption> = [
        ...accounts.map((account) => ({ value: String(account.id), label: accountLabel(account, privateType, companyType) })),
        { value: ADD_NEW_VALUE, label: '+ Neues Rechnungskonto anlegen' },
    ];
    const selectedOption = options.find((option) => option.value === assignment)
        || (inlineOpen ? options.find((option) => option.value === ADD_NEW_VALUE) : null)
        || null;

    return (
        <div className="exam-type-account">
            <Select
                placeholder="Automatische Auswahl durch FPSB"
                name="exam_type_account"
                isClearable
                isSearchable={false}
                options={options}
                value={selectedOption}
                onChange={(option:any, action:any) => {
                    if (!option) {
                        if (action.action === 'clear') {
                            onAssign(null);
                        }
                        return;
                    }
                    if (option.value === ADD_NEW_VALUE) {
                        if (!inlineOpen) {
                            onAddNew();
                        }
                        return;
                    }
                    onAssign(option.value);
                }}
            />

            { inlineOpen && inlineDraft && (
                <div className="exam-type-account-new">
                    <InlineClientAccountForm
                        value={inlineDraft}
                        onChange={onInlineChange}
                        privateType={privateType}
                        companyType={companyType}
                        errors={inlineErrors}
                    />
                    <div className="exam-type-account-actions mb-3">
                        <Button
                            type="button"
                            buttonType="primary"
                            icon="check"
                            disabled={inlineSaving}
                            onClick={onInlineSave}
                        >{ inlineSaving ? 'Wird gespeichert …' : 'Übernehmen' }</Button>
                        <Button
                            type="button"
                            buttonType="filled-danger"
                            disabled={inlineSaving}
                            onClick={onInlineCancel}
                        >Verwerfen</Button>
                    </div>
                    { inlineSaveError && (
                        <div className="message error" role="alert"><span>{ inlineSaveError }</span></div>
                    ) }
                </div>
            ) }
        </div>
    );
};

export default ExamTypeAccountSelect;
